(() => {
  const init = () => document.querySelectorAll('[data-retailer-locator]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-store-state]')];
    const search = root.querySelector('[data-store-search-input]');
    const state = root.querySelector('[data-store-state-filter]');
    const count = root.querySelector('[data-store-count]');
    const frame = root.querySelector('iframe');
    const name = root.querySelector('[data-store-selected-name]');
    const address = root.querySelector('[data-store-selected-address]');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const choose = button => {
      root.querySelectorAll('[data-store-map]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      if (frame.getAttribute('src') !== button.dataset.storeMap) frame.src = button.dataset.storeMap;
      name.textContent = button.dataset.storeName;
      address.textContent = button.dataset.storeAddress;
    };
    const filter = () => {
      const terms = normalize(search.value).split(' ').filter(Boolean);
      const visible = cards.filter(card => {
        const text = normalize(card.dataset.storeSearch);
        const match = (!state.value || state.value === card.dataset.storeState) && terms.every(term => text.includes(term));
        card.hidden = !match;
        return match;
      });
      count.textContent = count.dataset.countTemplate.replace('__COUNT__', visible.length);
      root.querySelector('[data-store-empty]').hidden = visible.length > 0;
      root.querySelector('.k-store-map').hidden = visible.length === 0;
      const selected = root.querySelector('[data-store-map][aria-pressed="true"]');
      if (visible.length && (!selected || selected.closest('li').hidden)) choose(visible[0].querySelector('[data-store-map]'));
      root.querySelector('.k-store-results').scrollTop = 0;
    };
    search.addEventListener('input', filter);
    state.addEventListener('change', filter);
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-store-map]');
      if (button && root.contains(button)) choose(button);
    });
    filter();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
